import { Container, Row } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import SmHeader from "./_includes/SmHeader";
import Footer from "./_includes/Footer";
import { useSelector } from "react-redux";
import { selectIsLogged } from "../app/features/authSlice";

const AuthLayout = () => {
  const { lang } = useParams();
  const isLoggedIn = useSelector(selectIsLogged);
  const navigate = useNavigate();

  if (isLoggedIn) {
    return navigate(`/${lang}/dashboard`);
  }

  return (
    <Container
      fluid
      className="auth d-flex flex-column p-0"
      style={{ height: "100dvh" }}
    >
      <Row
        style={{ minHeight: 0 }}
        className="px-2 flex-grow-1 align-items-center justify-content-center overflow-y-auto px-3 py-4"
      >
        <SmHeader />
        <Outlet />
      </Row>
      <Footer />
      <Toaster position="bottom-center" reverseOrder={false} />
    </Container>
  );
};

export default AuthLayout;
